
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/review/viewUserReview",
      function () {
        return require("private-next-pages/review/viewUserReview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/review/viewUserReview"])
      });
    }
  